import React from "react";
import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";

export function PageHero({ eyebrow, title, subtitle, image, children }) {
  return (
    <section className="relative bg-navy text-white pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" loading="lazy" className="w-full h-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/90 to-navy/60" />
        </div>
      )}
      <div className="absolute inset-0 geo-overlay opacity-50 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl fade-up">
          {eyebrow && <span className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.18em] uppercase text-gold"><span className="w-6 h-px bg-gold" />{eyebrow}</span>}
          <h1 className="mt-4 text-3xl md:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05]">{title}</h1>
          {subtitle && <p className="mt-6 text-base md:text-lg text-slate-300 leading-relaxed max-w-2xl">{subtitle}</p>}
          {children && <div className="mt-8 flex flex-wrap gap-3">{children}</div>}
        </div>
      </div>
    </section>
  );
}

export function CTABand({ title = "Tell Us Where You Want Your Business to Go", text = "Start with a confidential assessment of your business, preferred country and expansion goals. Contact us to know more.", service = "General Inquiry", serviceKey = null }) {
  const { openWhatsApp } = useSite();
  return (
    <section className="relative bg-emerald-brand text-white py-16 md:py-20 overflow-hidden">
      <div className="absolute inset-0 songket-pattern opacity-30" />
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-bold tracking-tight">{title}</h2>
        <p className="mt-4 text-emerald-50 max-w-2xl mx-auto">{text}</p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/eligibility" data-testid="cta-start-assessment" className="btn-gold rounded-full px-7 py-3.5 font-bold">Start Your Assessment</Link>
          <button data-testid="cta-whatsapp" onClick={() => openWhatsApp({ service, serviceKey })} className="rounded-full px-7 py-3.5 font-bold bg-white/10 border-2 border-white/40 hover:bg-white/20 transition-colors">Speak on WhatsApp</button>
        </div>
      </div>
    </section>
  );
}
